// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";

// React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/chess-icon.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "IM CHESS Academy & Club",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/profile.php?id=61566587885208",
    },
    {
      icon: <WhatsAppIcon />,
      link: "https://chat.whatsapp.com/KCVQr2D3Z3I119uN5t98OD",
    },
    {
      icon: <InstagramIcon />,
      link: "https://www.instagram.com/imchess_academy?igsh=YWhzZTY0bHQyODc4&utm_source=qr",
    },
    {
      icon: <YouTubeIcon />,
      link: "https://www.youtube.com/@IMCHESS_Era",
    },
  ],
  menus: [
    {
      name: "IM CHESS",
      items: [
        { name: "Home", href: "/" },
        { name: "About us", href: "/about-us" },
        { name: "IM Manush Shah", href: "/im-manush-shah" },
      ],
    },
    // {
    //   name: "resources",
    //   items: [
    //     { name: "Open Job Profiles", href: "/" },
    //     // { name: "Online Batches", href: "/batch/online" },
    //     // { name: "Offline Batches", href: "/batch/offline" },
    //     // { name: "affiliate program", href: "/affiliates/new" },
    //   ],
    // },
    {
      name: "help & support",
      items: [
        { name: "contact us", href: "/contact-us" },
        { name: "knowledge center", href: "/knowledge-center" },
        // { name: "sponsorships", href: "/sponsorships" },
      ],
    },
    // {
    //   name: "legal",
    //   items: [
    //     { name: "terms & conditions", href: "/terms" },
    //     { name: "privacy policy", href: "/privacy" },
    //     // { name: "licenses (EULA)", href: "/license" },
    //   ],
    // },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date} IM CHESS{" "}.
    </MKTypography>
  ),
};
